import { CJAtelier } from 'types/cj';

export function isRotateInSeance(ateliers: CJAtelier[]): boolean {
  // If any pivot has position>1, we consider it in "rotate" mode
  return ateliers.some(a => (a.groupPivots || []).some(p => p.position > 1));
}
